export const WHOLE_CLASS_GROUP_ID = 0;

